import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AUTH_ROUTES } from '../constants';
import { authService } from '../services';
import { useAuthStore } from './use-auth-store';

/** Mutation de logout: encerra a sessao, limpa cache e volta ao login. */
export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const clear = useAuthStore((state) => state.clear);

  return useMutation({
    mutationFn: () => authService.logout(),

    onSettled: () => {
      clear();
      queryClient.clear();
      navigate(AUTH_ROUTES.LOGIN, { replace: true });
    },
  });
}
